<template>
  <div>
    <card-component
      title="Edit schools, grades and classes"
      icon="ballot-outline"
    >
      <div>
        <div>
          Select a project to load the structure
        </div>
        <hr />
        <b-field label="Project" horizontal>
          <b-select
            placeholder="Select a project"
            v-model="availableProjects.project"
            required
            @input="populateProjectStructure(availableProjects.project)"
          >
            <option
              v-for="(project, index) in projects"
              :key="index"
              :value="project.project"
            >
              {{ project.project }}
            </option>
          </b-select>
        </b-field>
      </div>
    </card-component>

    <card-component icon="ballot-outline" title="Edit Schools">
      <div
        class="school-form"
        v-for="(school, schoolIndex) in formObj.schools"
        :key="schoolIndex"
      >
        <b-field label="School Name" horizontal>
          <b-input
            icon="domain"
            v-model="formObj.schools[schoolIndex].name"
            placeholder="School Name"
            name="schoolName"
            required
          />

          <p class="control">
            <b-button
              icon-right="delete"
              class="button is-danger"
              @click="deleteSchool(schoolIndex)"
            ></b-button>
          </p>
        </b-field>

        <div
          v-for="(grade, gradeIndex) in formObj.schools[schoolIndex].grades"
          :key="gradeIndex"
          style="margin-left: 5rem;"
        >
          <b-field label="Grade" horizontal>
            <b-input
              icon="account-multiple"
              v-model="formObj.schools[schoolIndex].grades[gradeIndex].gradeNum"
              placeholder="Grade (must be number)"
              name="grade"
              required
            />
            <p class="control">
              <b-button
                icon-right="delete"
                class="button is-danger"
                @click="deleteGrade(schoolIndex, gradeIndex)"
              ></b-button>
            </p>
          </b-field>
          <b-field style="margin-left: 10rem; margin-bottom: 2rem;">
            <div class="control">
              <b-button type="is-primary" @click="addNewEmptyGrade(schoolIndex)"
                >Add New Grade
              </b-button>
            </div>
          </b-field>

          <div
            v-for="(clss, classIndex) in formObj.schools[schoolIndex].grades[
              gradeIndex
            ].classes"
            :key="classIndex"
            style="margin-left: 5rem;"
          >
            <b-field label="Class" horizontal>
              <b-input
                icon="book-variant"
                v-model="
                  formObj.schools[schoolIndex].grades[gradeIndex].classes[
                    classIndex
                  ]
                "
                placeholder="Class"
                name="class"
                required
              />
              <p class="control">
                <b-button
                  icon-right="delete"
                  class="button is-danger"
                  @click="deleteClass(schoolIndex, gradeIndex, classIndex)"
                ></b-button>
              </p>
            </b-field>
          </div>
          <b-field style="margin-left: 13rem; margin-bottom: 2rem;">
            <div class="control">
              <b-button
                type="is-primary"
                @click="addNewEmptyClass(schoolIndex, gradeIndex)"
                >Add New Class
              </b-button>
            </div>
          </b-field>
        </div>
      </div>
    </card-component>

    <card-component title="Ready to submit" icon="check-box-outline">
      <div v-if="presubmit">
        <b-field label="Project Name" horizontal>
          <div v-html="submission.projectName" />
        </b-field>
        <b-field label="Project Id" horizontal>
          <div v-html="submission.project" />
        </b-field>
        <div
          v-for="(school, schoolIndex) in submission.schools"
          :key="schoolIndex"
        >
          <b-field label="School Name" horizontal>
            <div v-html="school.name" />
          </b-field>
          <div
            v-for="(grade, gradeNum) in school.grades"
            :key="gradeNum"
            style="margin-left: 5rem;"
          >
            <b-field label="Grade" horizontal>
              <div v-html="gradeNum" />
            </b-field>
            <div
              v-for="(clss, classKey) in grade.classes"
              :key="classKey"
              style="margin-left: 5rem;"
            >
              <b-field label="Class" horizontal>
                <div v-html="classKey" />
              </b-field>
            </div>
            <hr />
          </div>
        </div>
      </div>
      <div v-else>
        Click preview to load project configuration. Once you're happy, press
        submit.
      </div>
      <b-field horizontal>
        <b-field grouped>
          <div class="control">
            <b-button
              :type="presubmit ? 'is-primary is-outlined' : 'is-primary'"
              @click="loadConfig()"
              v-html="
                presubmit ? 'Refresh configuration' : 'Preview configuration'
              "
            />
          </div>
          <div class="control">
            <b-button
              :type="
                presubmit
                  ? 'is-primary is-success'
                  : 'is-primary is-success is-outlined'
              "
              @click="submit()"
              :disabled="!presubmit"
              v-html="'Submit'"
            />
          </div>
          <div
            v-if="submitMessage"
            v-html="submitMessage.message"
            :style="submitMessage.submitted ? 'color: green;' : 'color: red;'"
          ></div>
        </b-field>
      </b-field>
    </card-component>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import mapValues from "lodash/mapValues";
import { mapState, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Subject } from "rxjs";

export default {
  name: "add-schools",
  components: {
    "card-component": CardComponent
  },
  data() {
    return {
      availableProjects: {
        project: null
      },
      submitMessage: null,
      submission: null,
      presubmit: false,
      formObj: {
        projectId: null,
        projectName: null,
        schools: []
      }
    };
  },
  computed: {
    ...mapState({
      projects: state => state.globalStore.projects,
      projectStructure: state => state.adminStore.projectStructure
    }),
    ...mapGetters({
      getProjectStructure: "adminStore/getProjectStructure"
    })
  },
  methods: {
    ...mapActions({
      fetchProjectStructure: "adminStore/fetchProjectStructure",
      loading: "SET_SCREEN_LOADING",
      updateProjectStructure: "adminStore/updateProjectStructure"
    }),

    addNewEmptyGrade(index) {
      return this.formObj.schools[index].grades.push({
        classes: []
      });
    },
    addNewEmptyClass(schoolIndex, gradeIndex) {
      return this.formObj.schools[schoolIndex].grades[gradeIndex].classes.push(
        ""
      );
    },
    deleteSchool(index) {
      return this.formObj.schools.splice(index, 1);
    },
    deleteGrade(schoolIndex, gradeIndex) {
      return this.formObj.schools[schoolIndex].grades.splice(gradeIndex, 1);
    },
    deleteClass(schoolIndex, gradeIndex, classIndex) {
      return this.formObj.schools[schoolIndex].grades[
        gradeIndex
      ].classes.splice(classIndex, 1);
    },
    loadConfig() {
      // RESET
      this.submission = {
        project: this.formObj.projectId.toUpperCase(),
        projectName: this.formObj.projectName,
        schools: []
      };

      // CONVERT SCHOOL LEVEL
      for (let schoolIndex in this.formObj.schools) {
        this.submission.schools.push({
          _id: this.formObj.schools[schoolIndex]._id,
          name: this.formObj.schools[schoolIndex].name,
          grades: {}
        });

        // CONVERT GRADE LEVEL
        for (let grade of this.formObj.schools[schoolIndex].grades) {
          this.submission.schools[schoolIndex].grades[
            parseInt(grade.gradeNum)
          ] = {
            classes: {}
          };

          for (let clss of grade.classes) {
            this.submission.schools[schoolIndex].grades[
              parseInt(grade.gradeNum)
            ].classes[clss] = {};
          }
        }
      }

      this.presubmit = true;
    },
    async populateProjectStructure(project) {
      this.loading(true);
      await this.fetchProjectStructure(project);
      let currentProject = this.getProjectStructure;
      this.formObj = {
        projectId: currentProject.project,
        projectName: currentProject.projectName,
        schools: currentProject.schools.map(school => {
          let schoolId = school._id ? school._id : school.schoolId;
          const mutatedSchool = {
            _id: schoolId,
            name: school.name,
            grades: Object.entries(school.grades).map(grade => {
              const mutatedGrade = {
                gradeNum: parseInt(grade[0]),
                classes: grade[1].classes
              };

              return mutatedGrade;
            })
          };

          return mutatedSchool;
        })
      };

      this.loading(false);
    },
    async submit() {
      this.loading(true);
      this.submitMessage = await this.updateProjectStructure(this.submission);
      this.loading(false);
    }
  }
};
</script>
